"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const FudaoClientApplicationServiceBase_1 = require("./FudaoClientApplicationServiceBase");
class FudaoClientApplicationService extends FudaoClientApplicationServiceBase_1.FudaoClientApplicationServiceBase {
}
exports.FudaoClientApplicationService = FudaoClientApplicationService;
//# sourceMappingURL=FudaoClientApplicationService.js.map